import React from "react";
import "./App.css";

function PrivacyPolicy() {
  return (
    <div className="section" style={{ maxWidth: "1000px", margin: "40px auto", lineHeight: "1.8", padding: "20px" }}>
      <h1 style={{ textAlign: "center", color: "#0b4f6c" }}>
        Privacy Policy
      </h1>

      <p>
        <strong>Effective Date:</strong> August 3, 2026
      </p>

      <p>
        Welcome to <strong>Raj Pipe Industries</strong>. We respect your privacy
        and are committed to protecting your personal information. This Privacy
        Policy explains how we collect, use, disclose, and safeguard your
        information when you visit our website
        <strong> https://rajpipe.in </strong>
        or contact us through our enquiry form, WhatsApp, or other communication
        channels.
      </p>

      <h2>1. Information We Collect</h2>

      <p>
        When you submit an enquiry on our website, we may collect the following
        information:
      </p>

      <ul>
        <li>Full Name</li>
        <li>Mobile Number</li>
        <li>District</li>
        <li>City</li>
      </ul>

      <p>
        We may also automatically collect certain technical information,
        including:
      </p>

      <ul>
        <li>IP Address</li>
        <li>Browser Type</li>
        <li>Device Information</li>
        <li>Operating System</li>
        <li>Pages Visited</li>
        <li>Date and Time of Visit</li>
      </ul>

      <h2>2. How We Use Your Information</h2>

      <p>Your information is used to:</p>

      <ul>
        <li>Respond to your enquiries.</li>
        <li>Provide quotations for our products.</li>
        <li>Contact you regarding your enquiry.</li>
        <li>Improve our products and services.</li>
        <li>Maintain customer records.</li>
        <li>Comply with legal obligations.</li>
      </ul>

      <h2>3. Cookies</h2>

      <p>
        Our website may use cookies and similar technologies to improve user
        experience, analyze website traffic, and enhance website functionality.
      </p>

      <p>
        You can disable cookies through your browser settings, although some
        website features may not function properly.
      </p>

      <h2>4. WhatsApp Communication</h2>

      <p>
        If you choose to contact us through WhatsApp, your communication is
        subject to WhatsApp's Privacy Policy. We only use WhatsApp to respond to
        customer enquiries and provide support.
      </p>

      <h2>5. Information Sharing</h2>

      <p>
        We do <strong>not</strong> sell, rent, or trade your personal
        information.
      </p>

      <p>Your information may be shared only:</p>

      <ul>
        <li>When required by law.</li>
        <li>With trusted service providers assisting our business.</li>
        <li>To protect our legal rights.</li>
        <li>To prevent fraud or misuse of our services.</li>
      </ul>

      <h2>6. Data Security</h2>

      <p>
        We implement reasonable technical and organizational measures to protect
        your information from unauthorized access, misuse, alteration, or
        disclosure.
      </p>

      <p>
        Although we strive to protect your personal information, no internet
        transmission is completely secure.
      </p>

      <h2>7. Data Retention</h2>

      <p>
        We retain your information only for as long as necessary to provide our
        services, respond to enquiries, or comply with legal requirements.
      </p>

      <h2>8. Third-Party Services</h2>

      <p>Our website may contain links to third-party services such as:</p>

      <ul>
        <li>WhatsApp</li>
        <li>Justdial</li>
        <li>Google Maps</li>
      </ul>

      <p>
        These third-party services maintain their own privacy policies. We
        encourage you to review them before using those services.
      </p>

      <h2>9. Your Rights</h2>

      <p>You have the right to:</p>

      <ul>
        <li>Request access to your personal information.</li>
        <li>Request correction of inaccurate information.</li>
        <li>Request deletion of your personal information.</li>
        <li>Withdraw consent where applicable.</li>
      </ul>

      <h2>10. Children's Privacy</h2>

      <p>
        Our website is intended for business and general users and is not
        directed toward children under the age of 13. We do not knowingly
        collect personal information from children.
      </p>

      <h2>11. Changes to This Privacy Policy</h2>

      <p>
        We may update this Privacy Policy from time to time. Changes will be
        posted on this page with the updated effective date.
      </p>

      <h2>12. Contact Us</h2>

      <p>
        <strong>Raj Pipe Industries</strong>
      </p>

      <p>
        Vill. Suara, P.O. Pahleja
        <br />
        Dehri, Rohtas
        <br />
        Bihar – 821305
      </p>

      <p>
        <strong>Phone:</strong> +91-7004630920
      </p>

      <p>
        <strong>Website:</strong> https://rajpipe.in
      </p>

      <p>
        If you have any questions regarding this Privacy Policy, please contact
        us using the details provided above.
      </p>

      <hr style={{ marginTop: "40px" }} />

      <p style={{ textAlign: "center", color: "#666" }}>
        © 2026 Raj Pipe Industries. All Rights Reserved.
      </p>
    </div>
  );
}

export default PrivacyPolicy;